import { model as i18n } from '!/i18n'
import { model as cartModel } from '$/cart'
import { model as paymentInfoModel } from '$/payment-info'
import { model as priceSettingsModel } from '$/price-settings'
import { model as tvBundleModel } from '$/tv/bundles'
import { createEvent, sample } from 'effector'
import { anyPaymentInitiated } from './model'

export const selectTvBundlePaymentButton = createEvent()

sample({
  clock: selectTvBundlePaymentButton,
  source: {
    bundle: tvBundleModel.$tvBundleWithContentFormatted,
    i18n: i18n.$t,
  },
  fn: ({ bundle, i18n: { t } }) => {
    if (!bundle) return null

    const itemCountLabel = t('live_channel_number', {
      count: bundle.contentQuantity,
    })

    return {
      name: bundle.name,
      title: t('extras'),
      imageUrl: bundle.landscapeImageUrl || '',
      labels: [itemCountLabel],
      priceSettings: bundle.priceSettings,
      bundlePoster: true,
    }
  },
  target: paymentInfoModel.$uiPaymentInfo,
})

sample({
  clock: selectTvBundlePaymentButton,
  source: tvBundleModel.$tvBundleWithContentFormatted,
  fn: (content) => {
    if (!content) return null

    return {
      channelSetId: content.id,
      channelIds: content.channelIds,
    }
  },
  target: cartModel.$tvBundleInfoForCart,
})

sample({
  clock: selectTvBundlePaymentButton,
  source: tvBundleModel.$tvBundleWithContentFormatted,
  fn: (content) => content?.priceSettings ?? null,
  target: priceSettingsModel.$priceSettings,
})

sample({
  clock: selectTvBundlePaymentButton,
  target: anyPaymentInitiated,
})
